module.exports = __webpack_public_path__ + "static/media/second-banner-mobile.f7f1a607.png";